import React, { Component } from 'react';
import { connect } from 'react-redux';

import DashboardDataContainer from 'containers/dashboard/DashboardDataContainer';
import Dashboard from 'components/dashboard';

class DashboardContainer extends Component {
  render = () => (
    <DashboardDataContainer
      render={({ company, subcompany, dashboard, fetch }) => (
        <Dashboard.View
          company={company}
          subcompany={subcompany}
          dashboard={dashboard}
          fetch={fetch}
        />
      )}
    />
  );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, null)(DashboardContainer);



// WEBPACK FOOTER //
// src/containers/dashboard/DashboardContainer.js